import useSWR from 'swr';
import useSWRMutation from 'swr/mutation';
import axios from 'axios';
import { FC, useEffect, useState } from 'react';
import ProductList from '../../components/productList';
import useDebounce from '../../hooks/useDebounce';
import { activateOrDeactivateProducts, getCatalogueList } from '../../services/cataloge';
import useFiltersState from '../../state/useFiltersState';
import errorMessage from '../../utils/errorMessage';
import CatalogueFilters from './Components/CatalogueFilters/CatalogueFilters';
import { getLoggedUserPermissions } from '../../services/configuration.service';
import PlusButton from '../../assets/images/searchBar/plusButton';
import { Button } from 'antd';
import { useHistory } from 'react-router-dom';
import EditIcon from '../../assets/images/catalogue/EditIcon';
import useCatalogueState from '../../state/useCatalogueState';
import { displaySuccessNotification } from '../../utils/displayNudosStandardNotifications';
import ActiveOrInactiveConfirmModal from './Components/ActiveOrInactiveConfirmModal';
import { SWR_KEYS } from '../../constants/constants';
import './Catalogue.scss';

interface ISearchBar {
  searchText?: string;
  setSearchText?: (text: string) => void;
  changeStateFirsLoad: (state: boolean) => void;
}

const CatalogueModule: FC<ISearchBar> = ({ searchText, changeStateFirsLoad }: ISearchBar) => {
  const { push } = useHistory();
  const { catalogueFilters } = useFiltersState();
  const {
    listOfCheckedProducts = [],
    activeProducts,
    setListOfCheckedProducts,
    setShowPricingForm
  } = useCatalogueState();
  const [makeFirstCharge, setMakeFirstCharge] = useState<boolean>(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const productDebounce = useDebounce(searchText, 800);
  const _userInfo = localStorage.getItem('_userInfo');
  const userInfo = _userInfo && JSON.parse(_userInfo);
  const storedUserNudosData = localStorage.getItem('userNudosData');
  const disableEditButton = !listOfCheckedProducts?.length;

  const filtersQuery =
    catalogueFilters && catalogueFilters.length > 0 ? `filters=${JSON.stringify(catalogueFilters)}` : '';
    const nameQuery =
    productDebounce && productDebounce?.length > 0 ? `${filtersQuery ? '&' : ''}commercialName=${productDebounce}` : '';
  const queries = !!filtersQuery || !!nameQuery ? `?${filtersQuery}${nameQuery}` : '';
  const renderActionButtonText = activeProducts
    ? 'Los SKUs se inactivaron correctamente'
    : 'Los SKUs se activaron correctamente';

  const swrKey = `${queries}`;

  const {
    mutate,
    data: productListData,
    isLoading,
    error
  } = useSWR([swrKey, activeProducts], () => getCatalogueList({ filters: swrKey, isActive: activeProducts }), {
    suspense: false
  });

  const { trigger: activateOrDeactivateProductsTrigger, isMutating: isLoadingActivateOrDeactivateProducts } =
    useSWRMutation(
      SWR_KEYS.activeOrdeactiveProducts,
      async (
        __,
        {
          arg
        }: {
          arg: {
            isActivate: boolean;
            body: number[];
          };
        }
      ) => {
        return await activateOrDeactivateProducts(arg);
      },
      {
        onSuccess: () => {
          mutate();
          setShowConfirmModal(false);
          setListOfCheckedProducts([]);
          displaySuccessNotification({
            customJSXMessage: <>{renderActionButtonText}</>
          });
        }
      }
    );

  const getNudosData = async () => {
    if (!userInfo) return;
    try {
      const userData = await getLoggedUserPermissions(userInfo.uuid);
      const userNudosData = JSON.stringify(userData);
      localStorage.setItem('userNudosData', userNudosData);
    } catch (error) {
      errorMessage();
    }
  };
  const initalLoader = () => {
    if (!isLoading || productListData || error) {
      if (!makeFirstCharge) {
        setMakeFirstCharge(true);
        changeStateFirsLoad(false);
      }
      if (error) {
        if (axios.isCancel(error)) {
          console.error('estado:request:', error?.message);
        } else {
          errorMessage();
        }
      }
    }
  };

  const handleActivateOrDeactivateProductsTrigger = () => {
    activateOrDeactivateProductsTrigger({ isActivate: activeProducts, body: listOfCheckedProducts });
  };

  useEffect(() => {
    initalLoader();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading, productListData, error]);

  useEffect(() => {
    !storedUserNudosData && userInfo && getNudosData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div id="catalogueModule">
      {showConfirmModal && (
        <ActiveOrInactiveConfirmModal
          firstButtonAction={() => setShowConfirmModal(false)}
          secondButtonAction={handleActivateOrDeactivateProductsTrigger}
          isLoading={isLoadingActivateOrDeactivateProducts}
        />
      )}
      <div className="numberOfProducts">- {isLoading ? 'Cargando' : productListData?.length || '0'} Productos</div>
      <div className="container">
        <div className="bodyCatalogue">
          <div className="filtersAndButtonContainer">
            <CatalogueFilters />
            <div className="buttonsContainer">
              <Button
                className={`${disableEditButton ? 'disableButton' : 'orangeButton'} buttonStyles`}
                icon={
                  <div className="iconStyle">
                    <EditIcon className="iconPositionButton" />
                  </div>
                }
                disabled={disableEditButton}
                onClick={() => setShowConfirmModal(true)}
              >
                Editar
              </Button>
              {activeProducts && (
                <Button
                  className={`${!disableEditButton ? 'disableButton' : 'orangeButton'} buttonStyles`}
                  onClick={() => {
                    setShowPricingForm(false);
                    push('/catalog/category-type');
                  }}
                  icon={
                    <div className="iconStyle">
                      <PlusButton className="iconPositionButton" />
                    </div>
                  }
                  disabled={!disableEditButton}
                >
                  Nuevo
                </Button>
              )}
            </div>
          </div>
          <ProductList data={productListData || []} loading={isLoading} />
        </div>
      </div>
    </div>
  );
};
export default CatalogueModule;
